module.exports = __webpack_public_path__ + "img/real_time_reports.403cad55.jpeg";